import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useEffect, useRef } from 'react';

export const TOOLTIP_ROOT_ID = 'tooltip-root';

export const TooltipPortal = ({ children }: { children: React.ReactNode }) => {
    const tooltipElRef = useRef(document.createElement('div'));

    useEffect(() => {
        const root = document.getElementById(TOOLTIP_ROOT_ID);
        const tooltipEl = tooltipElRef.current;

        if (root && !root.contains(tooltipEl)) {
            root.appendChild(tooltipEl);
        }

        return () => {
            if (tooltipEl.parentNode === root) {
                root?.removeChild(tooltipEl);
            }
        };
    }, []);

    return ReactDOM.createPortal(children, tooltipElRef.current);
};
